// test1758
(1758 && 0);
